import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M9.13008 56.8599C14.3901 52.3199 12.2401 43.77 12.2401 43.77C16.6601 36.17 12.6801 31.74 12.6801 31.74C18.1001 24.2 13.8001 18.1399 13.8001 18.1399C19.3901 11.2099 14.3701 3.70995 14.3701 3.70995C14.3701 3.70995 9.8301 -2.02003 3.6501 3.22997C3.6501 3.22997 -1.55994 10.5999 3.86006 17.6699C3.86006 17.6699 -0.589898 23.61 4.6501 31.29C4.6501 31.29 0.560116 35.62 4.79012 43.32C4.79012 43.32 2.42002 51.81 7.57002 56.48L9.13008 56.8599Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M2.66016 22.0901C2.66016 17.1401 9.16016 14.6001 9.16016 14.6001C9.16016 14.6001 16.1001 18.5601 14.7701 26.1601"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M3.66025 38.7199C2.12025 33.1099 8.50022 28.9199 8.50022 28.9199C8.50022 28.9199 14.1103 32.5499 13.6703 36.6299"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M4.76004 49.4C3.22004 43.79 8.50003 41.25 8.50003 41.25C8.50003 41.25 13.1201 44.33 12.6801 48.41"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
